import React, {useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl,} from '@mui/material';
import {useFormik} from 'formik';
import * as yup from 'yup';
import {toast} from 'react-toastify';
import {AxiosError} from "axios";
import Folder from "../../../../../models/Folder";
import {useApiService} from "../../../../../context/ApiServiceContext";
import CustomInput from "../../../../shared/form_controls/CustomInput";
import {StringKeys} from "../../../../../utils/types";

interface CreateNewFolderModalProps {
    parentFolderId: string;
    open: boolean;
    onClose: () => void;
    onFolderCreated: (folder: Folder, teamId?: string) => void;
}

const CreateNewFolderModal: React.FC<CreateNewFolderModalProps> = ({
                                                                       parentFolderId,
                                                                       open,
                                                                       onClose,
                                                                       onFolderCreated
                                                                   }) => {
    const apiService = useApiService();

    const [isLoading, setIsLoading] = useState(false)

    const folderSchema = yup.object().shape({
        name: yup.string().required('שם התיקיה נדרש'),
    });

    interface FormValues {
        name: string;
    }

    function addNewFolder(newFolder: FormValues) {
        setIsLoading(true)
        apiService.api
            .post<Folder>('/folder', {
                ...newFolder,
                parentFolderId
            })
            .then((response) => {
                onFolderCreated(response.data);
                toast.success('התיקיה נוספה בהצלחה');
                onClose();
                setIsLoading(false)
            })
            .catch((e: AxiosError<{ code: string }>) => {
                console.log(e)
                toast.error('תקלה בעת הוספת התיקיה');
                setIsLoading(false)
            });
    }

    const formik = useFormik<FormValues>({
        initialValues: {
            name: '',
        },
        validationSchema: folderSchema,
        onSubmit: (values) => {
            const newFolder = {
                ...values
            };

            console.log(newFolder)

            addNewFolder(newFolder);
        },
        validateOnBlur: true,
        validateOnMount: true,
        enableReinitialize: true,
    });

    const formFields = [
        {
            id: 'name',
            name: 'name',
            label: 'שם התיקיה',
            type: 'text',
            errorExpression: () => formik.touched.name && !!formik.errors.name,
            errorText: () => formik.errors.name,
            sx: {mb: 2},
            disabled: false
        }
    ];

    return (
        <Dialog open={open}
                onClose={() => {
                    onClose();
                    formik.resetForm();
                }}>
            <DialogTitle>הוסף תיקיה חדשה</DialogTitle>
            <form noValidate onSubmit={formik.handleSubmit}>
                <DialogContent>

                    {formFields.map((field, index) => (
                        <FormControl key={index} fullWidth sx={field.sx}>
                            <CustomInput
                                key={field.id}
                                id={field.id}
                                name={field.name}
                                label={field.label}
                                type={field.type}
                                value={formik.values[field.name as StringKeys<FormValues>]}
                                disabled={field.disabled || false}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={field.errorExpression()}
                                errorText={field.errorText()}
                            />
                        </FormControl>
                    ))}

                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} disabled={isLoading}>סגור</Button>
                    <Button type="submit" color="primary" disabled={isLoading}>שמור</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default CreateNewFolderModal;
